module.exports = __webpack_public_path__ + "img/image_002.9d27a413.png";